import { createReducer, on } from '@ngrx/store';
import { CwmConfig } from '@octiga/psa/cwm.interface';
import { deleteMspCwmIntegrationSuccess } from '../credentials/actions';
import * as actions from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'mspCwmConfig';

export interface State extends Status {
    data: CwmConfig | null;
}

export const initialState: State = {
    data: null,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,
    on(actions.loadMspCwmConfig, (state) => ({ ...state, loading: true })),
    on(actions.loadMspCwmConfigSuccess, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(actions.loadMspCwmConfigFailure, (state, { error }) => ({ ...state, error, loading: false })),

    on(actions.updateMspCwmConfigSuccess, (state) => ({ ...state })),
    on(deleteMspCwmIntegrationSuccess, () => initialState),
);

export const selectData = (state: State) => state.data;
